import * as React from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import * as state from '../../_state/purchaseOrderDetails.state';
import { EntityTabAttachments } from '../_shared/EntityTabAttachments';

export const PurchaseOrderTabAttachments = () => {
  const purchaseOrderDetails = useAtomValue(state.$purchaseOrderDetails);
  const uploadProgress = useAtomValue(state.$getUploadProgress);
  const addFiles = useSetAtom(state.$addPurchaseOrderAttachments);
  const deleteFile = useSetAtom(state.$deletePurchaseOrderFile);

  const files = React.useMemo(
    () => purchaseOrderDetails?.data?.customerFiles ?? [],
    [purchaseOrderDetails],
  );

  return (
    <EntityTabAttachments
      files={files}
      uploadProgress={uploadProgress}
      onAddFiles={addFiles}
      onDeleteFile={deleteFile}
      className="@PurchaseOrderTabAttachments"
    />
  );
};
